import React from "react";
import { Image, Layer } from "react-konva";

import { Background } from "./Background";
import { Offset, Size } from "./types";

interface IProps {
  readonly containerSize: Size;
  readonly image: HTMLImageElement;
  readonly offset: Offset;
  readonly size: Size;
}

export const PageImage = ({ containerSize, image, offset, size }: IProps) => {
  return (
    <Layer>
      <Background size={containerSize} />
      <Image image={image} {...offset} {...size} />
    </Layer>
  );
};
